module.exports = __webpack_public_path__ + "media/bootstrap-icons/filter-square-b8145e85.svg";